import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cn } from "../utils";
import { buttonVariants, iconVariants, spinnerSizeVariants, spinnerVariants, } from "./button.styles";
/**
 * Spinner component for loading state
 */
function Spinner({ size }) {
    return (_jsxs("svg", { className: spinnerVariants({ size }), xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "aria-hidden": "true", children: [_jsx("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }), _jsx("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" })] }));
}
/**
 * Renders the leading content (spinner or start icon)
 */
function LeadingContent({ loading, startIcon, size, }) {
    if (loading) {
        return _jsx(Spinner, { size: size });
    }
    if (startIcon) {
        return _jsx("span", { className: iconVariants({ size }), children: startIcon });
    }
    return null;
}
/**
 * Button component following Material Design 3 specifications.
 *
 * Supports five variants:
 * - `filled` - High emphasis primary action
 * - `filledTonal` - Medium emphasis secondary action
 * - `outlined` - Medium emphasis with border
 * - `text` - Low emphasis tertiary action
 * - `elevated` - High emphasis with shadow
 *
 * @example
 * ```tsx
 * <Button variant="filled" size="medium">
 *   Click me
 * </Button>
 *
 * <Button variant="outlined" startIcon={<AddIcon />}>
 *   Add Item
 * </Button>
 * ```
 */
export function Button({ variant = "filled", size = "medium", fullWidth = false, loading = false, disabled, startIcon, endIcon, children, className, onClick, onPress, testID, type = "button", ref, }) {
    const isDisabled = disabled || loading;
    // Support both onClick (web) and onPress (RN convention)
    const handleClick = onClick ?? onPress;
    return (_jsx("button", { ref: ref, type: type, disabled: isDisabled, onClick: handleClick, className: cn(buttonVariants({ variant, size, fullWidth }), className), "aria-busy": loading, "data-loading": loading ? "" : undefined, "data-testid": testID, children: loading ? (_jsxs(_Fragment, { children: [_jsx(Spinner, { size: size }), children && (_jsx("span", { className: "button-label shrink-0 truncate text-inherit", children: children })), endIcon && (_jsx("span", { className: spinnerSizeVariants({ size }), "aria-hidden": true }))] })) : (_jsxs(_Fragment, { children: [_jsx(LeadingContent, { loading: false, startIcon: startIcon, size: size }), children && (_jsx("span", { className: "button-label shrink-0 truncate text-inherit", children: children })), endIcon && (_jsx("span", { className: iconVariants({ size }), children: endIcon }))] })) }));
}
//# sourceMappingURL=Button.js.map